<template>
  <div class="p-4">
    <!-- Debug info (remove in production) -->
    <div v-if="showDebug" class="alert alert-info mb-4">
      <small>Debug: User ID: {{ user.id }}, Email: {{ user.email }}, Role: {{ user.role }}</small>
      <br>
      <small>API Call: GET /api/v2/user/{{ $route.params.id }}</small>
    </div>
    
    <div class="button-row d-flex justify-content-end mb-4">
      <button class="btn btn-sm btn-danger" type="button" @click="deleteItem(user.id)">
        Delete Customer
      </button>
    </div>

    <Form role="form" :validation-schema="schema" @submit="handleUpdate">
      <div class="row">
        <div class="col-md-6">
          <div class="input-group input-group-static mb-4">
            <label>Name</label>
            <Field
              type="text"
              class="form-control"
              v-model="user.name"
              name="name"
              id="name"
            />
            <ErrorMessage name="name" class="text-danger" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="input-group input-group-static mb-4">
            <label>Email</label>
            <Field
              type="text"
              class="form-control"
              v-model="user.email"
              name="email"
              id="email"
              readonly
            />
            <ErrorMessage name="email" class="text-danger" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="input-group input-group-static mb-4">
            <label>Role</label>
            <Field as="select" class="form-control" v-model="user.role" name="role" id="role">
              <option value="" disabled>Select Role</option>
              <option value="user">User</option>
              <option value="admin">Admin</option>
              <option value="adminuser">Adminuser</option>
            </Field>
            <ErrorMessage name="role" class="text-danger" />
          </div>
        </div>
      </div>

      <Field
        type="hidden"
        class="form-control"
        v-model="user.id"
        name="id"
        id="id"
      />

      <div class="button-row d-flex justify-content-end mt-4">
        <button class="btn btn-sm btn-dark" type="submit">
          Update User
        </button>
      </div>
    </Form>
  </div>
</template>

<script>
import userService from "@/services/users.service";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from 'yup';
import showSwal from "@/mixins/showSwal";
import Swal from 'sweetalert2';

export default {
  name: "Info5",
  
  components: {
    Form,
    Field,
    ErrorMessage
  },
  
  data() {
    return {
      user: {
        id: '',
        name: '',
        email: '',
        role: ''
      },
      schema: Yup.object().shape({
        email: Yup.string().email("Email has to be a valid email address").required("Email is a required input"),
        name: Yup.string().required("Name is a required input"),
        role: Yup.string().required("Role is a required input"),
      }),
      showDebug: false,
    };
  },
  
  methods: {
    async handleUpdate() {
      try {
        console.log('Updating user:', this.user);
        
        const payload = {
          id: this.user.id,
          name: this.user.name,
          email: this.user.email,
          role: this.user.role
        };
        
        await this.$store.dispatch('users/updateCustomer', payload);
        
        showSwal.methods.showSwal({
          type: "success",
          message: "User Updated Successfully",
          width: 500,
          timer: 160000,
          showConfirmButton: true
        });
        this.$router.push({ name: 'customers' });
      } catch (error) {
        console.error('Update error:', error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Error updating user!",
          width: 500
        });
      }
    },
    
    async deleteItem(id) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
      });

      if (result.isConfirmed) {
        try {
          await this.$store.dispatch('users/deleteCustomer', id);
          Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
          this.$router.push({ name: 'customers' });
        } catch (error) {
          console.error(`Error deleting customer with ID: ${id}`, error);
          Swal.fire('Error!', 'There was an error deleting the customer. Please try again.', 'error');
        }
      }
    },

    async fetchUserData() {
      const encodedVid = this.$route.params.id;
      try {
        const response = await userService.getUserById(encodedVid);
        
        let userData = response;
        if (response.data) {
          userData = response.data;
        }
        
        this.user = {
          id: userData.id || '',
          name: userData.name || '',
          email: userData.email || '',
          role: userData.role || ''
        };
        
        this.$nextTick(() => {
          this.$forceUpdate();
        });
        
      } catch (error) {
        console.error("Error fetching profile data:", error);
        
        let errorMessage = "Error loading user data!";
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage += " " + error.response.data.error;
        }
        
        showSwal.methods.showSwal({
          type: "error",
          message: errorMessage,
          width: 500
        });
      }
    }
  },
  
  async mounted() {
    await this.fetchUserData();
  }
};
</script>

<style scoped>
.alert {
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}
</style>